module.exports = __webpack_public_path__ + "img/item11.8ed8f7e9.png";